export const initialState = {
    id: '',
    title: '',
    description: '',
    isDefault: false,
    applications: {
        content: [],
        rules: []
    },
    settings: {
        ide: [],
        vmOptions: [],
        toolbox: [],
        autoinstalledTools: [],
        marketplace: []
    },
    plugins: {
        disabled: [],
        autoInstalled: [],
        rulesBundles: []
    },
    restrictions: {
        rules: []
    },
    constituents: {
        ai: {
            isEnabled: false,
            allowDataCollection: false,
            provider: undefined,
            allowLocalProviders: false,
            isJunieEnabled: false
        },
        idep: { isEnabled: false },
        cwm: { isEnabled: false }
    },
    version: 0
};
